import { SearchBar } from '@/components/Common';
import { DataTable } from '@/components/Ui';
import { Status, useFinance } from '@/pages/Finances/finances.hook';
import React from 'react';
import filterIcon from '@/assets/icons/filterIcon.svg';

export const FinanceList = () => {
  const {
    columns,
    transactionList,
    financeListLimit,
    setFinanceListLimit,
    transactions,
    statusConfig,
    financeListPage,
    setFinanceListPage,
  } = useFinance();

  const getStatusDisplay = (status: string) => {
    const statusKey = status as Status;
    const config = statusConfig[statusKey];
    return config ? (
      <span className={config.color}>{config.label}</span>
    ) : (
      <span>{status}</span>
    );
  };

  const datalist = transactionList?.map((item) => {
    return {
      ...item,
      status: getStatusDisplay(item.status.toLocaleUpperCase()),
      client: (
        <div className="flex items-center">
          <div>
            {item.client}
            <span className="block text-slateGray">{item.phoneNumber}</span>
          </div>
        </div>
      ),
    };
  });

  return (
    <div className="w-full">
      <div className="flex items-center justify-between bg-raisinBlack py-4 pl-7 rounded-[8px] mt-10">
        <div className="flex items-center gap-2">
          <SearchBar
            placeholder="Rechercher par numéro (ex: 771234567)"
            className="!w-[400px]"
          />
          <div className="relative">
            <div className="ml-[11px] size-[45px] bg-darkGray rounded-[8px] flex items-center justify-center">
              <img src={filterIcon} alt="filter" className="cursor-pointer" />
            </div>
          </div>
        </div>
        <p className="text-white text-2xl font-bold mr-5">980 transactions</p>
      </div>
      <DataTable
        columns={columns}
        value={datalist || []}
        withPaginator={true}
        countTotal={transactions?.total}
        currentPageHandler={setFinanceListPage}
        currentPage={financeListPage}
        listlimit={financeListLimit}
        limitHandler={setFinanceListLimit}
      />
    </div>
  );
};
